/* Shared header behavior: nav drawer, shop dropdown, cart drawer.
   Loaded globally (deferred) by layout/theme.liquid.
   Exposes window.ngCartAdd(items, attributes) for the PDP buy buttons. */
(function () {
  'use strict';

  var overlay = document.getElementById('shOverlay');
  var drawer = document.getElementById('shDrawer');
  var navOpen = document.getElementById('shNavOpen');
  var navClose = document.getElementById('shDrawerClose');
  var shopItem = document.getElementById('shShopItem');
  var shopBtn = document.getElementById('shShopBtn');
  var shopDrop = document.getElementById('shShopDrop');
  var cartDrawer = document.getElementById('cartDrawer');
  var cartOpenBtn = document.getElementById('shCartOpen');
  var cartCloseBtn = document.getElementById('shCartClose');
  var cartBody = document.getElementById('cartBody');
  var cartEmpty = document.getElementById('cartEmpty');
  var cartFoot = document.getElementById('cartFoot');
  var cartSubtotal = document.getElementById('cartSubtotal');
  var cartCount = document.getElementById('shCartCount');
  var cartCheckout = document.getElementById('cartCheckout');
  if (!overlay || !drawer || !cartDrawer) return;

  // ── Attribution params carried onto header links ──────────────────
  var search = window.location.search;
  if (search.length > 1) {
    document.querySelectorAll('.sh-header a.js-keep-params, .sh-drawer a.js-keep-params, .cart-drawer a.js-keep-params').forEach(function (a) {
      try {
        var url = new URL(a.href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        new URLSearchParams(search).forEach(function (value, key) {
          if (!url.searchParams.has(key)) url.searchParams.set(key, value);
        });
        a.href = url.toString();
      } catch (e) { /* leave link as-is */ }
    });
  }

  // ── Overlay-managed panels (nav drawer left, cart drawer right) ────
  function setPanel(panel, open) {
    panel.classList.toggle('open', open);
    panel.setAttribute('aria-hidden', String(!open));
    var anyOpen = drawer.classList.contains('open') || cartDrawer.classList.contains('open');
    overlay.classList.toggle('open', anyOpen);
    document.body.style.overflow = anyOpen ? 'hidden' : '';
    if (navOpen) navOpen.setAttribute('aria-expanded', String(drawer.classList.contains('open')));
  }
  function closeAll() {
    setPanel(drawer, false);
    setPanel(cartDrawer, false);
    setDropdown(false);
  }

  if (navOpen) navOpen.addEventListener('click', function () { setPanel(cartDrawer, false); setPanel(drawer, true); });
  if (navClose) navClose.addEventListener('click', function () { setPanel(drawer, false); });
  overlay.addEventListener('click', closeAll);
  drawer.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { setPanel(drawer, false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  // ── Shop dropdown (desktop): hover opens, click toggles ────────────
  var dropTimer = null;
  function setDropdown(open) {
    if (!shopItem) return;
    shopItem.classList.toggle('open', open);
    if (shopBtn) shopBtn.setAttribute('aria-expanded', String(open));
    if (shopDrop) shopDrop.setAttribute('aria-hidden', String(!open));
  }
  if (shopItem && shopBtn) {
    // Click always opens; outside click / Esc / mouseleave close. A toggle
    // here would fight the hover-open (hover then click = instant close).
    shopBtn.addEventListener('click', function () { setDropdown(true); });
    shopItem.addEventListener('mouseenter', function () {
      if (window.matchMedia('(hover: hover)').matches) { clearTimeout(dropTimer); setDropdown(true); }
    });
    shopItem.addEventListener('mouseleave', function () {
      if (window.matchMedia('(hover: hover)').matches) {
        dropTimer = setTimeout(function () { setDropdown(false); }, 150);
      }
    });
    document.addEventListener('click', function (e) {
      if (!shopItem.contains(e.target)) setDropdown(false);
    });
  }

  // ── Slimmer header once scrolled ───────────────────────────────────
  var header = document.querySelector('.sh-header');
  if (header) {
    var onHeaderScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 10);
    };
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
    onHeaderScroll();
  }

  // ── Drawer shop accordion ──────────────────────────────────────────
  var dShopBtn = document.getElementById('shDrawerShopBtn');
  var dShopPanel = document.getElementById('shDrawerShop');
  if (dShopBtn && dShopPanel) {
    dShopBtn.addEventListener('click', function () {
      var open = dShopPanel.hidden;
      dShopPanel.hidden = !open;
      dShopBtn.classList.toggle('open', open);
      dShopBtn.setAttribute('aria-expanded', String(open));
    });
  }

  // ── Cart ───────────────────────────────────────────────────────────
  function fmtMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function renderCart(cart) {
    if (cartCount) {
      cartCount.hidden = cart.item_count === 0;
      cartCount.textContent = cart.item_count;
    }
    var isEmpty = cart.item_count === 0;
    if (cartEmpty) cartEmpty.hidden = !isEmpty;
    if (cartFoot) cartFoot.hidden = isEmpty;
    if (cartSubtotal) cartSubtotal.textContent = fmtMoney(cart.items_subtotal_price);
    if (!cartBody) return;
    cartBody.innerHTML = '';
    cart.items.forEach(function (item, i) {
      var line = document.createElement('div');
      line.className = 'cart-line';

      var img;
      if (item.image) {
        img = document.createElement('img');
        img.className = 'cart-line-img';
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/, '_128x$1$2');
        img.alt = '';
      } else {
        img = document.createElement('span');
        img.className = 'cart-line-img cart-line-img--empty';
      }
      line.appendChild(img);

      var info = document.createElement('div');
      info.className = 'cart-line-info';

      var title = document.createElement('p');
      title.className = 'cart-line-title';
      title.textContent = item.product_title;
      info.appendChild(title);
      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('p');
        variant.className = 'cart-line-variant';
        variant.textContent = item.variant_title;
        info.appendChild(variant);
      }

      var row = document.createElement('div');
      row.className = 'cart-line-row';

      var qty = document.createElement('div');
      qty.className = 'cart-qty';
      var minus = document.createElement('button');
      minus.type = 'button'; minus.textContent = '−';
      minus.setAttribute('aria-label', 'Decrease quantity');
      minus.addEventListener('click', function () { changeLine(i + 1, item.quantity - 1); });
      var num = document.createElement('span');
      num.className = 'cart-qty-num'; num.textContent = item.quantity;
      var plus = document.createElement('button');
      plus.type = 'button'; plus.textContent = '+';
      plus.setAttribute('aria-label', 'Increase quantity');
      plus.addEventListener('click', function () { changeLine(i + 1, item.quantity + 1); });
      qty.appendChild(minus); qty.appendChild(num); qty.appendChild(plus);
      row.appendChild(qty);

      var price = document.createElement('span');
      price.className = 'cart-line-price';
      price.textContent = fmtMoney(item.final_line_price);
      row.appendChild(price);
      info.appendChild(row);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'cart-line-remove';
      remove.textContent = 'Remove';
      remove.addEventListener('click', function () { changeLine(i + 1, 0); });
      info.appendChild(remove);

      line.appendChild(info);
      cartBody.appendChild(line);
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  function changeLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { refreshCart(); });
  }

  function openCart() {
    setPanel(drawer, false);
    setPanel(cartDrawer, true);
    refreshCart();
  }

  if (cartOpenBtn) cartOpenBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', function () { setPanel(cartDrawer, false); });

  // Add lines (from PDP buy buttons), stamp attribution, open the drawer.
  window.ngCartAdd = function (items, attributes) {
    var add = fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    });
    var stamped = add.then(function () {
      if (!attributes || Object.keys(attributes).length === 0) return null;
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      });
    });
    return stamped.then(function () { openCart(); });
  };

  // Checkout: route through the discount endpoint when a code is active.
  if (cartCheckout) {
    cartCheckout.addEventListener('click', function () {
      cartCheckout.disabled = true;
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var value = cart.items_subtotal_price / 100;
          if (typeof fbq !== 'undefined') fbq('track', 'InitiateCheckout', {
            content_type: 'product',
            currency: 'USD',
            value: value,
            num_items: cart.item_count
          });
          if (typeof gtag !== 'undefined') gtag('event', 'begin_checkout', { currency: 'USD', value: value });
          if (typeof window.ngTrack === 'function') {
            window.ngTrack('checkout_redirect', { source: 'cart_drawer', currency: 'USD', value: value, counts_as_checkout: true });
          }
          if (typeof window.ngFlushTracking === 'function') window.ngFlushTracking(true);
        })
        .catch(function () {})
        .then(function () {
          var code = null;
          try { code = sessionStorage.getItem('ng_discount'); } catch (e) {}
          window.location.href = code
            ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/checkout')
            : '/checkout';
        });
    });
  }

  refreshCart();
})();
